export default __webpack_public_path__ + "static/media/rotate-right.8992f484.svg";